<template>
  <div class="row">
    <div class="title-row flex">
      <i v-if="demand.type === Trade.Demand" class="custom-icon icon-demand"/>
      <i v-if="demand.type === Trade.Supply" class="custom-icon icon-supply"/>
      <div class="flex-1">
        <el-link class="title" @click="itemClick">{{demand.title}}</el-link>
        <!--span class="money"><i class="custom-icon icon-coins"/>已提交意向金{{demand.intention}}元</span-->
      </div>
      <div v-if="demand.status === Trade.Status.Tendering" class="status-tendering">招标中</div>
      <div v-if="demand.status === Trade.Status.Verify" class="status-verify">待审核</div>
      <div v-if="demand.status === Trade.Status.UnderCarriage" class="status-under-carriage">已下架</div>
    </div>
    <div class="info-row flex">
      <!--div class="flex-2">行业:{{demand.industryName}}</div>
      <div class="flex-1">数量:{{demand.quantity}}</div>
      <div class="flex-1">预算:{{formatDecimal(demand.budget)}}元</div>
      <div class="flex-1">付款方式:{{demand.paycodeName}}</div>
      <div class="flex-1">发票:{{demand.invoiceName}}</div-->
      <table class="width100">
        <tr>
          <td width="15%" class="table-label">行业</td>
          <td width="35%">{{demand.industryName}}</td>
          <td width="15%" class="table-label">意向金</td>
          <td width="35%">{{demand.intention}}元</td>
        </tr>
        <tr>
          <td class="table-label">数量</td>
          <td>{{demand.quantity}}</td>
          <td class="table-label">预算</td>
          <td>{{formatDecimal(demand.budget)}}元</td>
        </tr>
        <tr>
          <td class="table-label">付款方式</td>
          <td>{{demand.paycodeName}}</td>
          <td class="table-label">发票</td>
          <td>{{formatDecimal(demand.invoiceName)}}元</td>
        </tr>
      </table>
    </div>
    <el-row class="image-row" :gutter="10">
      <el-col v-for="(image,index) in demand.tradeAttachmentList" :key="index" :span="50">
        <el-image style="height: 60px" fit="fill" :src="IMAGE_BASE_URL + image.name" :preview-src-list="plainImage"></el-image>
      </el-col>
    </el-row>
    <div class="tag-row flex">
      <div class="flex-1">
        <i class="custom-icon icon-location"/><span>{{demand.provinceName}}-{{demand.cityName}}-{{demand.townName}}</span>
      </div>
      <div class="flex-1 text-c">
        <div class="tag"><i class="custom-icon icon-eye"/><span>{{demand.readCount}}</span></div>
        <div class="tag"><i class="custom-icon icon-star"/><span>{{demand.collectionCount}}</span></div>
        <div class="tag"><i class="custom-icon icon-link"/><span>{{demand.dockingCount}}</span></div>
      </div>
      <div class="flex-1 text-r">
        {{formatDate(new Date(demand.createTime),'yyyy年MM月dd日')}}
      </div>
    </div>
  </div>
</template>

<script>
  import { Trade, IMAGE_BASE_URL } from '../util/constants'
  import { formatDate, formatDecimal } from '../util/common'
  export default {
    name: 'demand-list-item',
    props: {
      demand: Object
    },
    data() {
      return {
        Trade,
        IMAGE_BASE_URL
      }
    },
    computed: {
      plainImage() {
        let array = []
        this.demand.tradeAttachmentList.forEach(a => {
          if (a.fullName != null) {
            array.push(this.IMAGE_BASE_URL + a.fullName)
          } else {
            array.push(this.IMAGE_BASE_URL + a.name)
          }
        })
        return array
      }
    },
    methods: {
      formatDecimal,
      formatDate,
      itemClick() {
        this.$emit('titleClick', this.demand)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../style/variables.scss';
  .row {
    margin: 10px 0;
    padding: 10px 10px;
    border: 1px solid #d2d2d2;
  }
  .title-row {
    align-items: center;
    .status {
      padding: 5px 20px;
      border: 1px solid $theme-yellow;
      color: $theme-yellow;
    }
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-left: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      cursor: pointer;
    }
  }
  .info-row {
    color: #909399;
    margin-top: 10px;
    font-size: 14px;
  }

  .image-row {
    margin-top: 10px;
  }

  .tag-row {
    color: #909399;
    align-items: center;
    margin-top: 10px;
    font-size: 16px;
    & .tag {
      margin: 0 3px;
      display: inline;
      & span {
        margin-left: 5px;
      }
      & .icon-eye {
        top: 8px;
        position: relative;
      }
      & .icon-star {
        top: 5px;
        position: relative;
      }
      & .icon-link {
        top: 6px;
        position: relative;
      }
    }
  }

  .money {
    margin-left: 5px;
    color: #909399;
    font-size: 14px;
    & .icon-coins {
      position: relative;
      top: 4px;
    }
  }

  table {
    border-collapse: collapse;
    border: 1px solid #DFDFDF;
    font-size: 16px;
    td {
      padding: 4px 4px 4px 10px;
      height: 30px;
      border-collapse: collapse;
      border: 1px solid #DFDFDF;
    }
  }
  .table-label {
    padding: 0 15px;
    background-color: #f8f8f8;
    text-align: justify;
    text-align-last: justify;
    text-justify: distribute;
  }
</style>



// WEBPACK FOOTER //
// src/components/demand-list-item.vue